import React from 'react';

/*
  Envoltorio de las páginas de Membresías. La cabecera y el pie son los comunes de toda la web
  (components/site/PublicLayout): desde el 09/10/2026 Membresías ya no tiene un menú propio.
  Aquí solo queda el espacio bajo la cabecera fija y los estilos de impresión.
*/
export default function MembresiasLayout({ children }) {
  return (
    <div style={{ fontFamily: "'Nunito', sans-serif", color: '#2d2d2d' }}>
      <style>{`
        @media print { .no-print, [data-testid="main-navbar"], [data-testid="main-footer"] { display: none !important; } body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
      `}</style>
      <main style={{ paddingTop: 80 }}>{children}</main>
    </div>
  );
}
